import { styled } from '@mui/material/styles'

export const ItemUI = styled('div')(
    () => `
    width: 100%;
    display: flex;
    alignItems: center;
    justifyContent: space-between;
    flexWrap: wrap;
    display: flex;
  `
  )
  
  export const ActionsUI = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  })
  
export const sharedGenericStyling = {
    list: {
      overflow: 'hidden'
    },
    presentation: { 
      display: 'flex',
      alignItems: 'center',
      transition: '1s ease-out',
      overflow: 'hidden',
      flex: 1,
      '&:hover': {
        transform: 'translateY(2px)'
      }
    },
    actions: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
      '& button': {
        maxWidth: '180px'
      }
    }
  }